<app-classe-profit [disabled]="disabled" [uid]="getUid()" [parentForm]="parentForm" [classeProfit]="libelle?.classeProfit"></app-classe-profit>

<div class="siret-wrapper">
  <div class="siret">
    <app-form-input
      [parentForm]="parentForm"
      [value]="libelle?.siret"
      [label]="facturationMessage.SIRET"
      [type]="'text'"
      [disabled]="disabled"
      [rule]="'pattern_20|required'"
      [errorMessage]="{'pattern' : 'ctr_1216','required' : 'ctr_1210'}"
      [name]="getUid()+'_SepAtt_siret'">
    </app-form-input>
  </div>

  <button type="button"
          class="btn-verifier-siret btn btn-outline-primary"
          (click)="verifierSiret()">
    {{ facturationMessage.Verifier | translate }}
  </button>

  <button type="button" class="infobulle-siret" matTooltip="Informations"
          aria-label="Informations sur la récupération des données"
          (click)="ouvrirInfobulleSiret()">
    <mat-icon aria-hidden="true">info</mat-icon>
  </button>

  <div class="error">
    <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>
    <app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg4" [id]="getStepId() + rg4"></app-form-input-error>
  </div>
</div>

<app-form-input
     [parentForm]="parentForm"
     [value]="typeEntite"
     [label]="facturationMessage.TypeEntite"
     [type]="'radio'"
     [disabled]="disabled || !saisieManuelleFacturation"
     [rule]="'required'"
     [infoBulle]="facturationMessage.InfobulleTypeEntite | translate"
     [name]="typeEntiteCtrlName"
     [radios]="[
         { value: 'Publique', label: facturationMessage.TypeEntitePublique },
         { value: 'PriveeAssujettie', label: facturationMessage.TypeEntitePriveeAssujettie }
     ]">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="typeEntiteVerificationErrorCtrlName" [id]="typeEntiteVerificationErrorCtrlName">
</app-form-input-error>
<output class="type-entite-info" *ngIf="saisieManuelleFacturation">
  <span>{{ 'error.typeEntite_recuperationImpossible' | translate }}</span>
</output>
<output class="type-entite-info" *ngIf="divergenceTypeEntitePreference">
  <span>{{ 'error.typeEntite_divergentPreference' | translate }}</span>
</output>

<app-form-input *ngIf="typeEntite === 'Publique'" [parentForm]="parentForm" [value]="noServiceExecutant"
                [label]="facturationMessage.Nserviceexecutant"
                [type]="'text'" [disabled]="disabled" [rule]="'maxSize_100'"
                [name]="noServiceExecutantCtrlName">
</app-form-input>

<app-form-input *ngIf="typeEntite === 'PriveeAssujettie'" [parentForm]="parentForm" [value]="identifiantAdressage || ''"
                [label]="facturationMessage.IdentifiantAdressage"
                [type]="saisieManuelleFacturation ? 'text' : 'select'" [optionsWithCode]="identifiantsAdressageOptions"
                [rule]="'required|minSize_9|maxSize_125'" [name]="identifiantAdressageCtrlName" [disabled]="disabled"
                [errorMessage]="{'required' : 'ctr_identifiant_adressage_obligatoire', 'minLength' : 'ctr_identifiant_adressage_min', 'maxLength' : 'ctr_identifiant_adressage_max'}">
</app-form-input>
<output class="type-entite-info type-entite-info--error" *ngIf="identifiantAdressagePreferenceAbsente">
  <span>{{ 'error.identifiantAdressage_absentG2B' | translate }}</span>
</output>

<app-form-input *ngIf="typeEntite" [parentForm]="parentForm" [value]="numBonCommande"
                [label]="typeEntite === 'PriveeAssujettie' ? facturationMessage.NumeroBonCommande : facturationMessage.Nengagementjuridique"
                [type]="'text'" [disabled]="disabled" [rule]="'minSize_3|maxSize_50'"
                [errorMessage]="{'minLength' : 'ctr_numBonCommande_min', 'maxLength' : 'ctr_numBonCommande_max'}"
                [name]="numBonCommandeCtrlName">
</app-form-input>

<app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.denomination"
     [label]="facturationMessage.Denomination"
     [type]="'text'"
     [disabled]="disabled"
     [rule]="'minSize_1|maxSize_38|required'"
     [name]="getUid()+'_SepAtt_denomination'">
</app-form-input>

<app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.adr1"
     [label]="facturationMessage.Serviceoudestinataire"
     [type]="'text'"
     [disabled]="disabled"
     [rule]="'minSize_1|maxSize_38'"
     [name]="getUid()+'_SepAtt_adr1'">
</app-form-input>

<app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.adr2"
     [label]="facturationMessage.Immeublebatiment"
     [type]="'text'"
     [disabled]="disabled"
     [rule]="'minSize_1|maxSize_38'"
     [name]="getUid()+'_SepAtt_adr2'">
</app-form-input>

<app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.adr3"
     [label]="facturationMessage.Numerolibellevoie"
     [type]="'text'"
     [disabled]="disabled"
     [rule]="'minSize_1|maxSize_38|required'"
     [errorMessage]="{'required' : 'ctr_1091'}"
     [name]="getUid()+'_SepAtt_adr3'">
</app-form-input>

<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg3" [id]="getStepId() + rg3"></app-form-input-error>

<app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.adr4"
     [label]="facturationMessage.Complementadresseboitepostale"
     [type]="'text'"
     [disabled]="disabled"
     [rule]="'minSize_1|maxSize_38'"
     [name]="getUid()+'_SepAtt_adr4'">
</app-form-input>

<app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.cp"
     [label]="facturationMessage.Codepostal"
     [type]="'text'"
     [disabled]="disabled"
     [rule]="'pattern_3|required'"
     [errorMessage]="{'pattern' : 'ctr_1156'}"
     [name]="getUid()+'_SepAtt_cp'">
</app-form-input>
<app-form-input-error *ngIf="isNotEform()" [activeForm]="parentForm" [name]="getStepId() + rg5" [id]="getStepId() + rg5"></app-form-input-error>

<app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.ville"
     [label]="facturationMessage.Ville"
     [type]="'text'"
     [disabled]="disabled"
     [rule]="'minSize_1|maxSize_32|required'"
     [name]="getUid()+'_SepAtt_ville'">
</app-form-input>

 <app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.pays"
     [label]="facturationMessage.Pays"
     [type]="'select'"
     [typeSelect]="optionsSelectType"
     [optionsWithCode]="optionsSelect"
     [disabled]="disabled"
     [rule]="'pattern_25'"
     [errorMessage]="{'pattern' : 'ctr_48'}"
     [name]="getUid()+'_SepAtt_pays'">
</app-form-input>

<app-form-input
     [parentForm]="parentForm"
     [value]="libelle?.tvaIntracommunautaire"
     [label]="facturationMessage.tvaIntracommunautaire"
     [type]="'text'"
     [disabled]="disabled"
     [rule]="'minSize_2|maxSize_50'"
     [name]="getUid()+'_SepAtt_tvaIntracommunautaire'">
</app-form-input>
